var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "text-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-success btn-xs",
          on: {
            click: function ($event) {
              return _vm.editUser({ is_active: 1, options: { comment: null } })
            },
          },
        },
        [_vm._v("новый\n      владелец\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-sm mt-0 table-hover" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.users, function (u, i) {
          return u.is_active
            ? _c("tr", { key: u.id }, [
                _c("td", [_vm._v(_vm._s(i + 1))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("(" + _vm._s(u.id) + ") " + _vm._s(u.short_name)),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(u.full_name))]),
                _vm._v(" "),
                _c("td", [
                  !_vm.showAccess[u.id]
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          on: {
                            click: function ($event) {
                              return _vm.showUserAccess(u.id)
                            },
                          },
                        },
                        [_vm._v("показать\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAccess[u.id]
                    ? _c("p", [
                        _vm._v(
                          _vm._s(u.banking_login) +
                            ":" +
                            _vm._s(u.banking_password)
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(u.options && u.options.comment))]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-xs",
                      on: {
                        click: function ($event) {
                          return _vm.editUser(u)
                        },
                      },
                    },
                    [_vm._v("редактировать")]
                  ),
                ]),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Фамилия")]),
        _vm._v(" "),
        _c("th", [_vm._v("Полное имя")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доступ")]),
        _vm._v(" "),
        _c("th", [_vm._v("комментарий")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }